import Model, { attr, belongsTo } from '@ember-data/model';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class MessagingChannel extends Model {
  @attr('boolean') enabled!: boolean;
  @attr('string') reason!: string;
  @attr('boolean') usedForLastMessage!: boolean;

  @belongsTo('booking', { inverse: 'messagingChannels', async: false })
  booking!: ModelRegistry['booking'];

  @belongsTo('booking-request', { inverse: 'messagingChannels', async: false })
  bookingRequest!: ModelRegistry['booking-request'];

  @belongsTo('enquiry', { inverse: 'messagingChannels', async: false })
  enquiry!: ModelRegistry['enquiry'];
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'messaging-channel': MessagingChannel;
  }
}
